"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSession = exports.ReferralSource = exports.DocType = exports.BiometricType = exports.SecurityVerification = exports.VerifyCodeKey = exports.VerifyDataKey = exports.VerifyType = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
var VerifyType;
(function (VerifyType) {
    VerifyType["verify_recaptcha"] = "verify_recaptcha";
    VerifyType["verify_hcaptcha"] = "verify_hcaptcha";
    VerifyType["verify_captcha"] = "verify_captcha";
    VerifyType["verify_code"] = "verify_code";
    VerifyType["email_code"] = "email_code";
    VerifyType["sms_code"] = "sms_code";
    VerifyType["verify_otp"] = "verify_otp";
    VerifyType["otp_code"] = "otp_code";
    VerifyType["verify_password"] = "verify_password";
    VerifyType["password_secret"] = "password_secret";
    VerifyType["voice_code"] = "voice_code";
    VerifyType["verify_kyc"] = "verify_kyc";
    VerifyType["verify_reset_questions"] = "verify_reset_questions";
    VerifyType["verify_phone"] = "verify_phone";
    VerifyType["choose_reset"] = "choose_reset";
    VerifyType["verify_FaceId"] = "verify_FaceId";
    VerifyType["verify_TouchId"] = "verify_TouchId";
    VerifyType["verify_Passcode"] = "verify_Passcode";
    VerifyType["sms_email_code"] = "sms_email_code";
    VerifyType["hyperlink"] = "hyperlink";
    VerifyType["kyc_face"] = "kyc_face";
    VerifyType["verify_passkey"] = "verify_passkey";
    VerifyType["bind_passkey"] = "bind_passkey";
})(VerifyType = exports.VerifyType || (exports.VerifyType = {}));
exports.VerifyDataKey = {
    verify_captcha: "captcha_response",
    verify_code: "verify_code",
    email_code: "email_code",
    sms_code: "sms_code",
    verify_otp: "otp_code",
    verify_password: "password",
    password_secret: "password",
    voice_code: "voice_code", //验证码(语音)
};
exports.VerifyCodeKey = {
    email_code: "email_code_id",
    sms_code: "sms_code_id",
    voice_code: "voice_code_id",
};
var SecurityVerification;
(function (SecurityVerification) {
    SecurityVerification["otp"] = "otp";
    SecurityVerification["phone_number"] = "phone_number";
    SecurityVerification["email"] = "email";
})(SecurityVerification = exports.SecurityVerification || (exports.SecurityVerification = {}));
var BiometricType;
(function (BiometricType) {
    BiometricType["FaceId"] = "FaceId";
    BiometricType["TouchId"] = "TouchId";
    BiometricType["Passcode"] = "Passcode";
})(BiometricType = exports.BiometricType || (exports.BiometricType = {}));
var DocType;
(function (DocType) {
    DocType["ID_CARD"] = "ID_CARD";
    DocType["PASSPORT"] = "PASSPORT";
    DocType["DRIVING_LISENCE"] = "DRIVING_LISENCE";
})(DocType = exports.DocType || (exports.DocType = {}));
var ReferralSource;
(function (ReferralSource) {
    /**
     * 双币理财
     */
    ReferralSource["dual_bonus"] = "dual_bonus";
})(ReferralSource = exports.ReferralSource || (exports.ReferralSource = {}));
class AccountSession {
    constructor(params, action) {
        this.params = params;
        this.action = action;
        this.verifyParamData = {};
        //判断请求verify_code时是短信还是邮箱
        this.verifyCodeType = VerifyType.email_code;
        this.sessionHandler = (param, resultHandler, errorHandler) => {
            this.verifyParamData = Object.assign(Object.assign({}, this.verifyParamData), param.data);
            let verifyObservable = (0, rxjs_1.of)({});
            const verifyCodeTypes = [];
            let hasVerifyCode = false;
            const codeIds = {};
            for (const require of param.require) {
                if (require === VerifyType.email_code || require === VerifyType.sms_code || require === VerifyType.verify_otp) {
                    verifyCodeTypes.push(require);
                    if (require === VerifyType.email_code) {
                        codeIds[exports.VerifyCodeKey[VerifyType.email_code]] = param.data.email_code_id;
                    }
                    else if (require === VerifyType.sms_code) {
                        codeIds[exports.VerifyCodeKey[VerifyType.sms_code]] = param.data.sms_code_id;
                    }
                }
                else if (require === VerifyType.otp_code) {
                    verifyCodeTypes.push(VerifyType.verify_otp);
                }
                else if (require === VerifyType.verify_code) {
                    verifyCodeTypes.push(this.verifyCodeType);
                    hasVerifyCode = true;
                }
                else if (require === VerifyType.verify_kyc ||
                    require === VerifyType.kyc_face ||
                    require === VerifyType.verify_reset_questions ||
                    require === VerifyType.verify_phone ||
                    require === VerifyType.choose_reset) {
                    verifyCodeTypes.push(require);
                }
                else if (require === VerifyType.verify_FaceId ||
                    require === VerifyType.verify_TouchId ||
                    require === VerifyType.verify_Passcode) {
                    verifyCodeTypes.push(require);
                }
                else if (require === VerifyType.verify_passkey || require === VerifyType.bind_passkey) {
                    verifyCodeTypes.push(require);
                }
                else if (require.includes("|")) {
                    const optionalVerifyCodeTypes = require.split("|");
                    verifyObservable = verifyObservable.pipe((0, operators_1.concatMap)((data) => {
                        return this.getVerifyData(optionalVerifyCodeTypes, this.verifyParamData, codeIds, param.verify_failed, true).pipe((0, operators_1.map)((result) => {
                            return Object.assign(Object.assign({}, result), data);
                        }));
                    }));
                }
                else {
                    verifyObservable = verifyObservable.pipe((0, operators_1.concatMap)((data) => {
                        return this.verify(require, param.data).pipe((0, operators_1.map)((result) => {
                            return Object.assign(Object.assign({}, result), data);
                        }));
                    }));
                }
            }
            if (verifyCodeTypes.length > 0) {
                const codeVerifyObservable = this.getVerifyData(verifyCodeTypes, this.verifyParamData, codeIds, param.verify_failed).pipe((0, operators_1.map)((verifyData) => {
                    if (hasVerifyCode) {
                        verifyData.verify_code = verifyData[exports.VerifyDataKey[this.verifyCodeType]];
                        delete verifyData[exports.VerifyDataKey[this.verifyCodeType]];
                    }
                    return verifyData;
                }));
                let first = verifyObservable;
                let second = codeVerifyObservable;
                if (this.isSignUp) {
                    // 注册时先输入验证码再输入密码
                    first = codeVerifyObservable;
                    second = verifyObservable;
                }
                verifyObservable = first.pipe((0, operators_1.mergeMap)((firstResult) => {
                    return second.pipe((0, operators_1.map)((secondResult) => {
                        return Object.assign(Object.assign({}, firstResult), secondResult);
                    }));
                }));
            }
            this.verifySubscription = verifyObservable.subscribe((data) => {
                resultHandler(data);
            }, (error) => {
                this.verifySubscription = undefined;
                if (error.code === "-10") {
                    this.cancel();
                    errorHandler({ code: -10, message: "Canceled by user" });
                    this.params.onCancel();
                }
                else {
                    errorHandler(error);
                }
            });
        };
        this.cancel = () => {
            this.verifyParamData = {};
            if (this.subscription) {
                this.subscription.unsubscribe();
                this.subscription = undefined;
            }
            if (this.verifySubscription) {
                this.verifySubscription.unsubscribe();
                this.verifySubscription = undefined;
            }
        };
        this.handleVerifyData = (data) => data;
        this.getVerifyData = (verifyTypes, paramData, codeIds, verify_failed, optional) => {
            return new rxjs_1.Observable((subscriber) => {
                this.params.requestVerifyData({
                    action: this.action,
                    verifyTypes,
                    paramData,
                    codeIds,
                    verify_failed,
                    optional,
                    callback: (data) => {
                        subscriber.next(this.handleVerifyData(data));
                        subscriber.complete();
                    },
                });
            });
        };
    }
    verify(verifyType, param) {
        switch (verifyType) {
            case VerifyType.verify_captcha:
                return (0, rxjs_1.of)(0).pipe((0, operators_1.mergeMap)(() => {
                    if (this.params.requestGtCaptcha) {
                        const captcha_data = JSON.parse(param.captcha_data);
                        return this.params.requestGtCaptcha({
                            captchaId: captcha_data.gt,
                            riskType: captcha_data.risk_type,
                            lang: this.params.lang,
                        });
                    }
                    else if (this.params.requestCaptcha) {
                        return this.params.requestCaptcha(param.captcha_data);
                    }
                    else {
                        return (0, rxjs_1.throwError)({ message: "AccountSession requestGtCaptcha not config" });
                    }
                }), (0, operators_1.map)((captcha_response) => {
                    var _a;
                    return { captcha_response: captcha_response, biometric_key_md5: (_a = this.params.biometricKeyMd5) !== null && _a !== void 0 ? _a : "" };
                }));
            case VerifyType.verify_recaptcha:
                return this.params.requestReCaptcha({
                    keyType: param.key_type,
                    siteKey: param.site_key,
                    action: this.action,
                    lang: this.params.lang,
                });
            case VerifyType.verify_hcaptcha:
                return this.params.requestHCaptcha({
                    siteKey: param.site_key,
                    lang: this.params.lang,
                });
            case VerifyType.verify_password:
            case VerifyType.password_secret:
                return this.getPassword().pipe((0, operators_1.map)((password) => {
                    return { password };
                }));
        }
        throw {
            code: -1,
            message: "verify type not support",
        };
    }
    getPassword() {
        return new rxjs_1.Observable((subscriber) => {
            if (!this.params.requestPassword) {
                subscriber.error("requestPassword is undefined");
                subscriber.complete();
            }
            else {
                this.params.requestPassword((code) => {
                    subscriber.next(code);
                    subscriber.complete();
                });
            }
        });
    }
}
exports.AccountSession = AccountSession;
